import Link from 'next/link';
import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';

const HeroSection = () => {
  return (
    <section className="relative min-h-[90vh] flex items-center justify-center overflow-hidden bg-background pb-16 lg:pb-24">
      {/* Background Container Image with Blur */}
      <div className="absolute inset-0 z-0">
        <AppImage
          src="/assets/images/container-at-beach-1771033342858.png"
          alt="Premium shipping container at beach showcasing quality construction and professional delivery"
          className="w-full h-full object-cover" />

        {/* Dark overlay for better text readability - 50% opacity */}
        <div className="absolute inset-0 bg-black/50" />

        {/* Gradient overlay for enhanced text contrast */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-background/80" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10 py-20 md:py-32 text-center">
        {/* Badge */}
        <div className="reveal inline-flex items-center gap-2 bg-primary/10 text-primary font-medium rounded-full px-6 py-2 mb-8">
          <Icon name="CheckBadgeIcon" size={20} />
          <span className="text-sm">Turn-Key Solutions</span>
        </div>

        {/* Hero Headline */}
        <h1 className="reveal text-4xl md:text-5xl lg:text-6xl font-bold font-montserrat leading-tight tracking-tight mb-6 text-white" style={{ textShadow: '2px 2px 8px rgba(0,0,0,0.8), 0 0 20px rgba(0,0,0,0.6)' }}>
          <span className="block">Premium Container Solutions</span>
          <span className="block text-primary drop-shadow-[0_2px_8px_rgba(0,0,0,0.9)]">For Your Business</span>
        </h1>

        {/* Subheadline */}
        <p className="reveal text-lg md:text-xl text-white max-w-3xl mx-auto mb-12 leading-relaxed" style={{ textShadow: '2px 2px 6px rgba(0,0,0,0.8), 0 0 15px rgba(0,0,0,0.5)' }}>
          Premium container solutions for restaurants, coffee shops, and bars. Transform your business with our fully-equipped, customizable containers.
        </p>

        {/* CTA Buttons */}
        <div className="reveal flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            href="/models-pricing"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-primary text-primary-foreground font-semibold rounded-full px-8 py-4 sm:py-5 hover:bg-primary/90 transition-all hover:scale-[0.98] shadow-lg touch-manipulation min-h-[56px] text-base sm:text-lg">

            Browse Catalog
            <Icon name="ArrowRightIcon" size={20} />
          </Link>
          <Link
            href="/get-a-quote"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-white border-2 border-primary text-primary font-semibold rounded-full px-8 py-4 sm:py-5 hover:bg-primary/10 transition-all touch-manipulation min-h-[56px] text-base sm:text-lg">

            <Icon name="DocumentTextIcon" size={20} />
            Request Quote
          </Link>
        </div>

        {/* Stats */}
        <div className="reveal flex flex-wrap items-center justify-center gap-8 md:gap-12 mt-16">
          <div className="text-center">
            <div className="text-3xl md:text-4xl font-bold text-white mb-1" style={{ textShadow: '2px 2px 6px rgba(0,0,0,0.8)' }}>4-6</div>
            <div className="text-sm text-white/90" style={{ textShadow: '1px 1px 4px rgba(0,0,0,0.7)' }}>Weeks Production</div>
          </div>
          <div className="w-px h-12 bg-white/30" />
          <div className="text-center">
            <div className="text-3xl md:text-4xl font-bold text-white mb-1" style={{ textShadow: '2px 2px 6px rgba(0,0,0,0.8)' }}>100+</div>
            <div className="text-sm text-white/90" style={{ textShadow: '1px 1px 4px rgba(0,0,0,0.7)' }}>Containers Built</div>
          </div>
          <div className="w-px h-12 bg-white/30" />
          <div className="text-center">
            <div className="text-3xl md:text-4xl font-bold text-white mb-1" style={{ textShadow: '2px 2px 6px rgba(0,0,0,0.8)' }}>50</div>
            <div className="text-sm text-white/90" style={{ textShadow: '1px 1px 4px rgba(0,0,0,0.7)' }}>States Served</div>
          </div>
        </div>
      </div>

      {/* Floating Container Image */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-1/3 w-full max-w-5xl px-6 z-20 hidden lg:block">
        <div className="reveal bg-white rounded-2xl shadow-2xl overflow-hidden border border-gray-200">
          <AppImage
            src="https://img.rocket.new/generatedImages/rocket_gen_img_1c080aff1-1772943432136.png"
            alt="Modern food truck container with service window and outdoor seating area"
            className="w-full h-64 object-cover" />

        </div>
      </div>
    </section>);

};

export default HeroSection;